<template>
    <div class="ui-page">
        <ui-page-header title="Processos competitivos"
            subtitle="Cadastro do processo, conteúdo da vitrine, documentos e o caso a que ele pertence.">
            <v-btn v-if="$allowed('create')" color="primary" depressed :to="{ path: '/processo-competitivo/processos/novo' }"><v-icon left small>mdi-plus</v-icon>Novo processo</v-btn>
        </ui-page-header>

        <ui-table-card clearable :can-clear="!!search || !!status" class="mb-4" @clear="search = ''; status = null">
            <template #toolbar>
                <v-text-field v-model="search" placeholder="Código, nome, comitente ou caso" dense outlined hide-details prepend-inner-icon="mdi-magnify" class="ui-toolbar__search"></v-text-field>
                <v-select v-model="status" :items="statusItems" placeholder="Todas as situações" clearable dense outlined hide-details class="ui-toolbar__field" :menu-props="{ offsetY: true }"></v-select>
            </template>
        </ui-table-card>

        <div v-if="loading" class="ui-empty"><v-progress-circular indeterminate size="28" color="primary"></v-progress-circular></div>
        <ui-empty v-else-if="!visible.length" icon="mdi-bank-outline" :text="items.length ? 'Nenhum processo com esses filtros' : 'Nenhum processo cadastrado'" />
        <div v-else class="cp-cards">
            <button v-for="item in visible" :key="item.id" type="button" class="cp-card" @click="open(item)">
                <div class="cp-card__cover" :style="item.cover_url ? { backgroundImage: `url(${item.cover_url})` } : null">
                    <v-icon v-if="!item.cover_url" large>mdi-image-outline</v-icon>
                    <div class="cp-card__badges">
                        <ui-badge set="cp-process" :status="item.status" />
                        <ui-badge v-if="item.featured" text="Destaque" tone="purple" :dot="false" />
                    </div>
                </div>
                <div class="cp-card__body">
                    <div>
                        <div class="cp-card__slug">/{{ item.slug }}</div>
                        <div class="cp-card__name">{{ item.name }}</div>
                        <div class="ui-cell-sub">{{ item.seller_name || (item.client && item.client.name) }}<span v-if="item.client && item.client.type_label"> · {{ item.client.type_label }}</span></div>
                    </div>
                    <div class="cp-card__stats">
                        <div class="cp-card__stat">Ativos<strong>{{ item.stats.assets }} <span class="ui-muted" style="font-weight: 400;">em {{ item.stats.cities }} {{ item.stats.cities === 1 ? "município" : "municípios" }}</span></strong></div>
                        <div class="cp-card__stat">Avaliação<strong>{{ formatMoneyShort(item.stats.appraisal_total) }}</strong></div>
                        <div class="cp-card__stat">Etapas<strong>{{ item.stats.stages }}</strong></div>
                        <div class="cp-card__stat">Inscrições até<strong>{{ item.registration_ends_at ? formatSchedule(item.registration_ends_at).slice(0, 10) : "—" }}</strong></div>
                    </div>
                </div>
                <div class="cp-card__footer">
                    <span v-if="item.stats.current_stage">Etapa {{ item.stats.current_stage.number }} · {{ item.stats.current_stage.name }}</span>
                    <span v-else>Sem etapa vigente</span>
                    <span v-if="item.stats.current_stage && item.stats.current_stage.receiving_ends_at" class="ui-nowrap">até {{ formatSchedule(item.stats.current_stage.receiving_ends_at) }}</span>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { API, formatMoneyShort, formatSchedule, notifyError } from "@/components/competitive/competitive.util";

export default {
    name: "CompetitiveProcessList",
    data: () => ({
        items: [],
        loading: false,
        search: "",
        status: null,
        statusItems: [
            { value: "draft", text: "Rascunho" },
            { value: "in_progress", text: "Em andamento" },
            { value: "closed", text: "Encerrado" },
            { value: "cancelled", text: "Cancelado" },
        ],
    }),
    computed: {
        visible() {
            const term = this.search.trim().toLowerCase();
            return this.items.filter((item) => (!this.status || item.status === this.status)
                && (!term || [item.slug, item.name, item.seller_name, item.client && item.client.name].some((value) => String(value || "").toLowerCase().includes(term))));
        },
    },
    created() {
        this.load();
    },
    methods: {
        formatMoneyShort,
        formatSchedule,
        async load() {
            this.loading = true;
            try {
                const result = await axios.get(`${API}/processes`);
                this.items = result.data.content;
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.loading = false;
            }
        },
        open(item) {
            this.$router.push({ path: `/processo-competitivo/processos/${item.id}` });
        },
    },
};
</script>

<style lang="scss">
@import "../../components/competitive/competitive";
</style>
